import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["note"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DataTableEventHandlers from "@Shared/utils/application-mixins/data-table-events-mixin";
import { mapState, mapActions, mapGetters } from "vuex";
import { REMOVE_APPLICATION_GROUP } from "../../store/application-actions";
import { capitalize, cloneDeep, lowerCase } from "lodash";
import { CURRENT_APPLICATION } from "../../store/application-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AppNotesTable",
  mixins: [DataTableEventHandlers],
  props: {
    notes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      internalNotes: null,
      maxInlineNoteLength: 50,
      appNotesColumns: ["date", "username", "category", "mortgageTypei18N", "notes", "delete"],
      appNotesHeadings: {
        date: this.$t("global.words.date"),
        username: this.$t("internal-notes.userName"),
        category: this.$t("global.words.category"),
        mortgageTypei18N: this.$t("application-flow.labels.mortgageType"),
        notes: capitalize(this.$tc("global.words.note", 1)),
        delete: this.$t("client-profile.actions.deleteNote") // delete
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [CURRENT_APPLICATION])), mapState("ApplicationStore", ["calculatedValues"])), {}, {
    appNotesOptions() {
      return {
        filterable: false,
        sortable: [],
        columns: this.appNotesColumns,
        headings: this.appNotesHeadings,
        columnsClasses: {
          delete: "hidden-heading"
        },
        perPage: 99999
      };
    },
    formattedNotes() {
      var _context;
      if (!this.internalNotes) return [];
      return _mapInstanceProperty(_context = this.internalNotes).call(_context, _ref => {
        let {
            note: noteText
          } = _ref,
          note = _objectWithoutProperties(_ref, _excluded);
        return {
          date: note["entry-date"] && this.formatDate(note["entry-date"]) || null,
          username: note["user-details"] && this.formatUser(note["user-details"]) || null,
          category: this.$t(`application-form.${note.category}`),
          mortgageTypei18N: this.$t(`application-form.${note.mortgageType}`),
          notes: {
            noteText: noteText.length < this.maxInlineNoteLength || note.expanded ? noteText : `${noteText.substr(0, this.maxInlineNoteLength)} ...`,
            expanded: noteText && note.expanded
          },
          delete: null,
          index: note.index,
          mortgageType: note.mortgageType
        };
      });
    }
  }),
  watch: {
    notes(newNotes) {
      const oldInternalNotes = this.internalNotes;
      this.internalNotes = cloneDeep(newNotes);
      this.internalNotes.forEach(note => {
        const oldNote = _findInstanceProperty(oldInternalNotes).call(oldInternalNotes, data => note["entry-date"] === data["entry-date"] && note.note === data.note);
        if (oldNote) {
          note.expanded = oldNote.expanded;
        }
      });
    }
  },
  mounted() {
    this.internalNotes = cloneDeep(this.notes);
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [REMOVE_APPLICATION_GROUP])), {}, {
    handleDelete(rowData) {
      this.deleteNote(rowData);
    },
    formatDate(timestamp) {
      return this.$options.filters.moment(timestamp, "YYYY-MM-DD");
    },
    formatUser(userDetails) {
      return `${userDetails.givenName} ${userDetails.familyName}`;
    },
    getSubmissionDetailsIndex(mortgageType) {
      var _context2;
      return _findIndexInstanceProperty(_context2 = this.CURRENT_APPLICATION["submission-details"]).call(_context2, submission => submission["submission-details"]["mortgage-type"] === mortgageType);
    },
    deleteNote(rowData) {
      const noteIndex = rowData.index;
      const mortgageType = lowerCase(rowData.mortgageType);
      this.REMOVE_APPLICATION_GROUP({
        index: noteIndex,
        where: `['submission-details'][${this.getSubmissionDetailsIndex(mortgageType)}]['notes']`
      });
      this.$parent.handleSave();
    },
    expandNote(rowData) {
      var _context3;
      const mortgageType = rowData.mortgageType;
      const index = rowData.index;
      const selectedNoteIndex = _findIndexInstanceProperty(_context3 = this.internalNotes).call(_context3, note => note.mortgageType === mortgageType && note.index === index);
      const currentNote = this.internalNotes[selectedNoteIndex];
      this.internalNotes[selectedNoteIndex].expanded = !currentNote.expanded;
    }
  })
});